import React, { useEffect } from "react";
import { HardHat } from "lucide-react";

const LEGAL_LINKS = [
  { href: "/terms", label: "Terms of Service" },
  { href: "/privacy", label: "Privacy Policy" },
  { href: "/disclaimer", label: "Disclaimer" },
  { href: "/refund-policy", label: "Refund & Cancellation" },
];

export const LegalLayout = ({ title, updated, testid, children }) => {
  useEffect(() => { window.scrollTo(0, 0); }, []);
  return (
    <div className="min-h-screen bg-white flex flex-col" data-testid={testid}>
      <header className="border-b border-slate-100">
        <div className="max-w-5xl mx-auto px-6 py-4 flex items-center justify-between">
          <a href="/" className="flex items-center gap-2 text-slate-900" data-testid="legal-home-link">
            <div className="h-8 w-8 rounded-lg bg-emerald-900 flex items-center justify-center">
              <HardHat className="h-4 w-4 text-lime-300" strokeWidth={2.2} />
            </div>
            <span className="font-heading font-bold tracking-tight">BidMatchAI</span>
          </a>
          <a href="/signup" className="text-sm font-medium text-emerald-800 hover:text-emerald-900">Start free trial →</a>
        </div>
      </header>

      <main className="flex-1 max-w-3xl mx-auto px-6 py-14 w-full">
        <h1 className="font-heading text-3xl sm:text-4xl font-extrabold tracking-tight text-slate-900" data-testid="legal-title">{title}</h1>
        <p className="mt-3 text-sm text-slate-400">Last updated: {updated}</p>
        <div className="mt-10 text-[15px] leading-relaxed text-slate-600
          [&>h2]:text-slate-900 [&>h2]:font-semibold [&>h2]:text-lg [&>h2]:mt-10 [&>h2]:mb-2
          [&>p]:mb-4 [&>ul]:list-disc [&>ul]:pl-6 [&>ul]:mb-4 [&>ul>li]:mb-1.5
          [&_strong]:text-slate-800 [&_a]:text-emerald-700 [&_a]:underline">
          {children}
        </div>
      </main>

      <footer className="border-t border-slate-100 bg-slate-50">
        <div className="max-w-5xl mx-auto px-6 py-8">
          <div className="flex flex-wrap gap-x-6 gap-y-2 text-sm">
            {LEGAL_LINKS.map((l) => (
              <a key={l.href} href={l.href} className="text-slate-500 hover:text-emerald-800" data-testid={`legal-nav-${l.href.slice(1)}`}>{l.label}</a>
            ))}
          </div>
          <p className="mt-5 text-xs text-slate-400">© 2026 BidMatchAI. Questions? Email <a href="mailto:support@bidmatchai.io" className="text-emerald-700 underline">support@bidmatchai.io</a>.</p>
        </div>
      </footer>
    </div>
  );
};

export default LegalLayout;
